import React from 'react';
import { CalendarIcon } from 'lucide-react';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
import { EVENT_TYPES, EVENT_STATUSES } from '../../../data/eventSchema';
import type { EM } from './useEventManager';
export const EventBasicsSection: React.FC<{
  em: EM;
}> = ({
  em
}) => {
  const dk = useDarkClasses();
  const {
    formData,
    updateField
  } = em;
  return <div className={`p-6 rounded-xl shadow-sm ${dk.card}`} data-id="element-19271" data-mp="1wl7fil961uql">
      <h2 className={`text-lg font-bold mb-4 flex items-center ${dk.textHeading}`} data-id="element-19272" data-mp="1wjmlcwqrkdt9">
        <CalendarIcon className="w-5 h-5 mr-2 text-purple-500" data-id="element-19273" data-mp="21dh2bsezieon" />
        Event Basics
      </h2>

      <div className="space-y-4" data-id="element-19274" data-mp="1mokunwgub3ok">
        <div data-id="element-19275" data-mp="1rm47qt1sxaex">
          <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-19276" data-mp="1rluorpf6c3iq">
            Event Type <span className="text-red-500" data-id="element-19277" data-mp="1dm36vdlje2zg">*</span>
          </label>
          <select value={formData.eventType || ''} onChange={e => updateField('eventType', e.target.value)} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} data-id="element-19278" data-mp="1hnx2h7gvkgsr">
            <option value="" data-id="element-19279" data-mp="1nd5pqqvj72pr">Select Event Type</option>
            {EVENT_TYPES.map(type => <option key={type.value} value={type.value} data-id="element-19280" data-mp="22ag90mef1cw1">
                {type.label}
              </option>)}
          </select>
          {formData.eventType && <p className={`mt-1 text-xs ${dk.textFaint}`} data-id="element-19281" data-mp="19l91wz0wbez6">
              {EVENT_TYPES.find(t => t.value === formData.eventType)?.description}
            </p>}
        </div>

        <div data-id="element-19282" data-mp="1jc3xwv3y1sxt">
          <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-19283" data-mp="1jcls7m71px33">
            Event Name <span className="text-red-500" data-id="element-19284" data-mp="1ej0zo9o81vba">*</span>
          </label>
          <input type="text" value={formData.eventName || ''} onChange={e => updateField('eventName', e.target.value)} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} placeholder="e.g. Seattle Romance Mega-Signing 2026" data-id="element-19285" data-mp="qtq18yucgd0b" />
        </div>

        <div data-id="element-19286" data-mp="1fjktjtjfx0e0">
          <div className="flex justify-between items-end mb-1" data-id="element-19287" data-mp="1fjb17zaxah55">
            <label className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-19288" data-mp="1kdfawqbkp39x">
              Short Description <span className="text-red-500" data-id="element-19289" data-mp="1p9vy9iay7dly">*</span>
            </label>
            <span className={`text-xs ${formData.shortDescription?.length > 300 ? 'text-red-500' : dk.textFaint}`} data-id="element-19290" data-mp="slg5zeggeq55">
              {formData.shortDescription?.length || 0}/300
            </span>
          </div>
          <textarea rows={3} value={formData.shortDescription || ''} onChange={e => updateField('shortDescription', e.target.value)} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} placeholder="A brief summary of the event for cards and search results..." maxLength={300} data-id="element-19291" data-mp="11k1ml42d7v3a" />
        </div>

        <div data-id="element-19292" data-mp="6bhmkm683idt">
          <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-19293" data-mp="6bzq83v7syvr">
            Long Description (Optional)
          </label>
          <textarea rows={6} value={formData.longDescription || ''} onChange={e => updateField('longDescription', e.target.value)} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} placeholder="Full details about the event, schedule, special guests, etc." data-id="element-19294" data-mp="3srlv47dloehm" />
        </div>

        <div data-id="element-19295" data-mp="3eufeaicfspv1">
          <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-19296" data-mp="39t9ho9fnoig8">
            Event Status
          </label>
          <select value={formData.status || 'upcoming'} onChange={e => updateField('status', e.target.value)} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} data-id="element-19297" data-mp="34vgd1ku03wi2">
            {EVENT_STATUSES.map(status => <option key={status.value} value={status.value} data-id="element-19298" data-mp="1b2y6zpx64mda">
                {status.label}
              </option>)}
          </select>
        </div>
      </div>
    </div>;
};